import { Observable } from 'rxjs';

import { DOCUMENT } from '@angular/common';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ViDownloadService {
  constructor(
    @Inject(DOCUMENT) private readonly _document: Document,
    private readonly _httpClient: HttpClient,
  ) {}

  downloadFile(url: string): Observable<HttpResponse<Blob>> {
    return this._httpClient.get(url, { responseType: 'blob', observe: 'response' });
  }
}
